import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import MPageImage from "Utils/Helpers/MPageImage";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { get_site_data } from "http/components/SiteData";
import { setTamimaData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import AddTamimaData from "./components/Add";
import TableTamimaData from "./components/Table";

export default function TamimaData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [image, setImage] = useState(null);
  const { tamima } = useSelector((state) => ({
    tamima: state.mngr.tamima,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (tamima) getData();
  }, [tamima]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_site_data(67513);
    if (CheckApiStatus(response)) {
      setData(response.data.infos);
      setImage(response.data.image);
    }
    dispatch(setTamimaData(false));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 item size={{ lg: 5, md: 6, sm: 6, xs: 12 }}>
          <MPaper
            label={"New section"}
            content={<AddTamimaData />}
            className="h-100"
          />
        </Grid2>
        <Grid2 item size={{ lg: 3, md: 4, sm: 6, xs: 12 }}>
          <MPaper
            label={"Page Image"}
            content={<MPageImage image={image} page={"tamima"} />}
            className="h-100"
          />
        </Grid2>
        <Grid2 item size={{ xs: 12 }}>
          <MPaper
            label={"Sections list"}
            content={<TableTamimaData data={data} />}
            defaultExpanded={true}
          />
        </Grid2>
      </Grid2>
    </>
  );
}
